<template>
  <div class="infoWindowHeader">
    <InfoWindowName
      :info-window-name="localContent.title"
      :editing="editing"
      @updateName="(name) => localContent.updateName(name)"
    />
  </div>
  <div class="infoWindowBody">
    <div
      v-for="(field, index) in localContent.displayFields"
      :key="field+index"
      data-testid="infoWindowField"
      class="infoWindowField pb-3 d-flex flex-row align-center"
    >
      <div
        v-if="field.value"
        :key="'provider-color-' + index"
        class="provider-color-square"
        :style="getSquareStyle(field.value)"
      />
      <span class="display-field-text">{{ field.label }}</span>
    </div>
  </div>
</template>

<script>
import InfoWindowName from './sections/Header/InfoWindowName.vue';

export default {
  name: 'FeatureInfoWindow',
  components: {
    InfoWindowName,
  },
  props: {
    /** @type {import('@/lib/classes/InfoWindowContent')} */
    infoWindowContent: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      /** @type {boolean} */
      editing: false,
      /** @type {InfoWindowContent} */
      localContent: this.infoWindowContent,
    };
  },
  methods: {
    getSquareStyle(color) {
      return `
        background-color: ${color};
        border: 2px solid ${color};
      `;
    },
  },
};
</script>

<style lang="scss" scoped>
  .provider-color-square {
    background-color: black;
    width: 15px;
    height: 15px;
    margin-right: 8px;
  }
</style>

